<template>
    <div class="messaging-chats" v-loading=loading_message>
        <div v-show="showsProps.showMainPage">
            <chat-groups v-bind="showsProps" />
        </div>

        <div v-show="showsProps.showCreatNewGroup">
            <create-group v-bind="showsProps" />
        </div>

        <div v-show="showsProps.showCreateNewPrivateChat">
            <create-private v-bind="showsProps" />
        </div>

        <div v-show="showsProps.showEditGroup">
            <edit-group v-bind="showsProps" />
        </div>
				
        <div v-show="showsProps.showChatRooms">
            <chats-room v-bind="showsProps" />
        </div>
    </div>
</template>
<script>
import ChatGroups from '@/views/Messaging/Chats/ChatGroups'
import CreateGroup from '@/views/Messaging/Chats/CreateGroup'
import CreatePrivate from '@/views/Messaging/Chats/CreatePrivate'
import EditGroup from '@/views/Messaging/Chats/EditGroup'
import ChatsRoom from '@/views/Messaging/Chats/ChatsRoom'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useConfigStore } from '@/stores/configStore'
import { useAuthStore } from '@/stores/authStore'

export default {
    components: {
        ChatGroups,
        CreateGroup,
        CreatePrivate,
        ChatsRoom,
        EditGroup
    },
    data() {
        return {
            showsProps: {
                showMainPage: true,
                showCreatNewGroup: false,
                showCreateNewPrivateChat: false,
                showChatRooms: false,
                showEditGroup: false
            }
        }
    },
    created() {
        chatEventBus.$on('show-create-chat-group', this.showCreateGroup)
        chatEventBus.$on('show-create-private-chat', this.showCreatePrivate)
        chatEventBus.$on('go-back-to-chat-main', this.goBack)
        chatEventBus.$on('show-chats-room', this.showChats)
        chatEventBus.$on('reset-shows-props', this.resetShowsProps)
        chatEventBus.$on('show-edit-chat-group', this.showEditChatGroup)
    },
    beforeDestroy() {
        chatEventBus.$off('show-create-chat-group', this.showCreateGroup)
				chatEventBus.$off('show-create-private-chat', this.showCreatePrivate)
        chatEventBus.$off('go-back-to-chat-main', this.goBack)
        chatEventBus.$off('show-chats-room', this.showChats)
        chatEventBus.$off('reset-shows-props', this.resetShowsProps)
        chatEventBus.$off('show-edit-chat-group', this.showEditChatGroup)
    },
    computed: {
        ...mapState(useMessagingStore,['messages', 'selected_group', 'replying_to', 'messages_pagination', 'loading_message']),
        ...mapState(useConfigStore,['app_code']),
        ...mapState(useAuthStore,['auth_user']),
    },
    methods: {
        // ...mapActions(useMessagingStore,['getGroupMessage']),
        showCreateGroup() {
            this.showsProps.showCreatNewGroup = true
            this.showsProps.showCreateNewPrivateChat = false
            this.showsProps.showMainPage = false
            this.showsProps.showChatRooms = false
            this.showsProps.showEditGroup = false
        },
        showCreatePrivate() {
						this.showsProps.showCreateNewPrivateChat = true
            this.showsProps.showCreatNewGroup = false
            this.showsProps.showMainPage = false
            this.showsProps.showChatRooms = false
            this.showsProps.showEditGroup = false
        },
        goBack() {
            this.showsProps.showMainPage = true
						this.showsProps.showCreateNewPrivateChat = false
            this.showsProps.showCreatNewGroup = false
            this.showsProps.showChatRooms = false
            this.showsProps.showEditGroup = false
        },
        showChats() {
            this.showsProps.showChatRooms = true
						this.showsProps.showCreateNewPrivateChat = false
            this.showsProps.showMainPage = false
            this.showsProps.showCreatNewGroup = false
            this.showsProps.showEditGroup = false
				},
        showEditChatGroup() {
            this.showsProps.showEditGroup = true
						this.showsProps.showCreateNewPrivateChat = false
            this.showsProps.showCreatNewGroup = false
            this.showsProps.showMainPage = false
            this.showsProps.showChatRooms = false
        },
        resetShowsProps() {
            this.showsProps = {
                showMainPage: false,
								showCreateNewPrivateChat: false,
                showCreatNewGroup: false,
                showChatRooms: true,
                showEditGroup: false
            }
        },
    }
}
</script>